/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ReferenceProperty } from '../models/reference-property';

@Injectable({ providedIn: 'root' })
export class SystemLinkControllerService extends DataBaseService {

  /**
   * Path part for operation systemLinkControllerGenerateToken
   */
  static readonly SystemLinkControllerGenerateTokenPath = '/v1/system-link/generate';

  /**
   * Generate random token
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generateToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  generateToken$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, SystemLinkControllerService.SystemLinkControllerGenerateTokenPath, 'get');
    if (params) {
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Generate random token
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `generateToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  generateToken(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<any> {

    return this.generateToken$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation systemLinkControllerGetAnonymousView
   */
  static readonly SystemLinkControllerGetAnonymousViewPath = '/v1/system-link/resolve/{token}';

  /**
   * Get anonymous view or generic view
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAnonymousView()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAnonymousView$Response(params: {
    token: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<ReferenceProperty>> {

    const rb = new RequestBuilder(this.rootUrl, SystemLinkControllerService.SystemLinkControllerGetAnonymousViewPath, 'get');
    if (params) {
      rb.path('token', params.token, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReferenceProperty>;
      })
    );
  }
  /**
   * Get anonymous view or generic view
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAnonymousView$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAnonymousView(params: {
    token: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<ReferenceProperty> {

    return this.getAnonymousView$Response(params).pipe(
      map((r: StrictHttpResponse<ReferenceProperty>) => r.body as ReferenceProperty)
    );
  }

}
